
let token;
if (sessionStorage.getItem("token")) {
    token = sessionStorage.getItem("token")
} else {
    token = localStorage.getItem("token")
}
let headers;
let key;
if (token) {
    headers = {
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    };
    key = {
        key: "value"
    };
}

export { token, headers, key };